import actions from "@/core/store/configuracao/fiscais/actions";
import mutations from "@/core/store/configuracao/fiscais/mutations";
import state from "@/core/store/configuracao/fiscais/state";

export default {
	actions,
	mutations,
	state,
}
